import { Client } from '@/utilities/api/Client';
import { CategoryMappingEndpoint } from '@api/endpoints';

export class CategoryMappingApi {
  static list (
    retailerId: string,
  ): Promise<CategoryMappingEndpoint.ListForRetailer.Response> {
    return Client(`retailer/${retailerId}/category-mappings`);
  }

  static sync (
    retailerId: string,
    body?: CategoryMappingEndpoint.Sync.Request,
  ): Promise<CategoryMappingEndpoint.Sync.Response> {
    return Client(`retailer/${retailerId}/category-mappings`, { body, method: 'PUT' });
  }
}
